import { Result } from "antd";
import { Layout } from "layout";
import { Admin, Authentication, Question } from "page";
import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAppSelector } from "store";
import "./App.less";

interface ProtectedRouteProps {
	children: JSX.Element;
}
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
	const location = useLocation();
	const user = useAppSelector((state) => state.user);

	if (!user && location.pathname.indexOf("admin") !== -1) {
		return <Navigate to="/auth/login" state={{ from: location }} replace />;
	}

	return children;
};

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Layout />}>
					<Route
						path="/"
						element={
							<ProtectedRoute>
								<Question />
							</ProtectedRoute>
						}></Route>
					<Route
						path="/admin/*"
						element={
							<ProtectedRoute>
								<Admin />
							</ProtectedRoute>
						}></Route>
				</Route>
				<Route path="/auth/login" element={<Authentication />}></Route>

				<Route path="*" element={<Result status="500" title="500" subTitle="Sorry, something went wrong." />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
